import { DELPHI_DATE_TIME_FORMAT } from '../../../const/constants';

const WMCodesLookupLayout = (customParams = {}) => {
    return {
        valueExpr: 'code',
        displayExpr: 'code',
        sort: [{ selector: "code", desc: false }],
        searchEnabled: true,
        acceptCustomValue: true,
        gridKey:'1D162747-4C24-4CD2-8195-6DC14A07456E',
        params: {
            module: "wm",
            lookupType: "WMCode",
            showLookupGrid: true,
            ...customParams
        },
        columns: [
            { dataField: "id", caption: "ID", dataType: "string", visible: false },
            { dataField: "code", caption: "Code", dataType: "string" },
            { dataField: "description1", caption: "Description1", dataType: "string" },
            { dataField: "description2", caption: "Description2", dataType: "string" },
            { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", format: DELPHI_DATE_TIME_FORMAT, visible: false },
            { dataField: "creationuserid", caption: "Created By", dataType: "string", visible: false },
            { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "datetime", format: DELPHI_DATE_TIME_FORMAT, visible: false },
            { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible: false },
            { dataField: "companyid", caption: "Company ID", dataType: "string", visible: false },
            { dataField: "module", caption: "Module", dataType: "string", visible: false },
            { dataField: "popupmessage", caption: "Popup Message", dataType: "string", visible: false },
            { dataField: "codetype", caption: "Type", dataType: "string", visible: false },
        ]
    };
}

// WMCODES descriptive-code lookup as the Delphi data-profile screens show it
// (frmIMM0007.qryWMDescriptiveCodes): the query is already filtered to one company, module and code
// type, so the columns carrying the same value on every row - ROWID, COMPANYID, MODULE, POPUPMESSAGE,
// CODETYPE - are not offered, and the two descriptions read "Description - 1" / "Description - 2".
//
// Derived from WMCodesLookupLayout rather than copied, so a column added there still flows through.
// Takes its own gridKey because the lookup grid persists column state per key, and the shared key
// would let another screen's saved layout - which still knows the omitted columns - be restored here.
const DESCRIPTIVE_CODES_OMITTED_COLUMNS = ['id', 'companyid', 'module', 'popupmessage', 'codetype'];
const DESCRIPTIVE_CODES_COLUMN_CAPTIONS = {
    description1: 'Description - 1',
    description2: 'Description - 2',
};

const WMDescriptiveCodesLookupLayout = (codeType, gridKey) => {
    const shared = WMCodesLookupLayout({ codeType });
    return {
        ...shared,
        gridKey,
        columns: shared.columns
            .filter((column) => !DESCRIPTIVE_CODES_OMITTED_COLUMNS.includes(column.dataField))
            .map((column) => (
                DESCRIPTIVE_CODES_COLUMN_CAPTIONS[column.dataField]
                    ? { ...column, caption: DESCRIPTIVE_CODES_COLUMN_CAPTIONS[column.dataField] }
                    : column
            )),
    };
};

const WMItemDpLookupLayout = {
    valueExpr: 'id',
    displayExpr: 'profilecode',
    sort: [{ selector: "profilecode", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '05119b3f-85aa-4e29-bb67-02caa19bbe9e',
    selectboxlabel: 'Profile',
    params: {
        module: "wm",
        lookupType: "WMItemDp",
        showLookupGrid: true
    },
    columns:  [
        /* { dataField: "id", caption: "ID", dataType: "string", visible: false }, */
        { dataField: "profilecode", caption: "Profile Code", dataType: "string" },
        { dataField: "description", caption: "Description", dataType: "string" },
        { dataField: "Coreitemusage", caption: "Address - 1", dataType: "string", visible:false },
        { dataField: "Kitcodeformat", caption: "Address - 2", dataType: "string", visible:false},
        { dataField: "Autogenalternateitem", caption: "City", dataType: "string", visible:false},
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "creationuserid", caption: "Created By", dataType: "string", visible:false},
        { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible:false},
        { dataField: "userdefinedcode1", caption: "Code 1", dataType: "string", visible:false},
        { dataField: "userdefinedcode2", caption: "Code 2", dataType: "string", visible:false},
        { dataField: "userdefinedcode3", caption: "Code 3", dataType: "string", visible:false},
        { dataField: "userdefinedcode4", caption: "Code 4", dataType: "string", visible:false},
        { dataField: "userdefinedcode5", caption: "Code 5", dataType: "string", visible:false},
        { dataField: "recordnumber", caption: "Record #", dataType: "string", visible:false}
    ]
};

const WMRateScheduleHeaderLookupLayout = (customParams = {}) => {
    return {
        valueExpr: 'id',
        displayExpr: 'schedulecode',
        sort: [{ selector: "schedulecode", desc: false }],
        searchEnabled: true,
        acceptCustomValue: true,
        gridKey:'959ac18d-8524-418a-b224-b28089512c1e',
        params: {
            module: "wm",
            lookupType: "Wmratescheduleheaders",
            showLookupGrid: true,
            ...customParams
        },
        columns: [
            { dataField: "scheduletype", caption: "Type", dataType: "string" },
            { dataField: "schedulecode", caption: "Code", dataType: "string" },
            { dataField: "description", caption: "Description", dataType: "string" },
            {dataField: "userdefinedcode1", caption: "Code 1", dataType: "string", visible:false},
            { dataField: "userdefinedcode2", caption: "Code 2", dataType: "string", visible:false},
            { dataField: "userdefinedcode3", caption: "Code 3", dataType: "string", visible:false},
            { dataField: "userdefinedcode4", caption: "Code 4", dataType: "string", visible:false},
            { dataField: "userdefinedcode5", caption: "Code 5", dataType: "string", visible:false},
            { dataField: "userdefinedcode6", caption: "Code 6", dataType: "string", visible:false},
            { dataField: "userdefinedcode7", caption: "Code 7", dataType: "string", visible:false},
            { dataField: "userdefinedcode8", caption: "Code 8", dataType: "string", visible:false},
            { dataField: "userdefinedcode9", caption: "Code 9", dataType: "string", visible:false},
            { dataField: "userdefinedcode10", caption: "Code 10", dataType: "string", visible:false},
            { dataField: "userdefinedreference1", caption: "Reference 1", dataType: "string", visible:false},
            { dataField: "userdefinedreference2", caption: "Reference 2", dataType: "string", visible:false},
            { dataField: "userdefinedreference3", caption: "Reference 3", dataType: "string", visible:false},
            { dataField: "userdefinedreference4", caption: "Reference 4", dataType: "string", visible:false},
            { dataField: "userdefinedreference5", caption: "Reference 5", dataType: "string", visible:false},
            { dataField: "userdefineddate1", caption: "Date 1", dataType: "datetime", format:"MM/dd/yyyy", visible:false},
            { dataField: "userdefineddate2", caption: "Date 2", dataType: "datetime", format:"MM/dd/yyyy", visible:false},
            { dataField: "userdefineddate3", caption: "Date 3", dataType: "datetime", format:"MM/dd/yyyy", visible:false},
            { dataField: "userdefineddate4", caption: "Date 4", dataType: "datetime", format:"MM/dd/yyyy", visible:false},
            { dataField: "userdefineddate5", caption: "Date 5", dataType: "datetime", format:"MM/dd/yyyy", visible:false},
            { dataField: "userdefineddate6", caption: "Date 6", dataType: "datetime", format:"MM/dd/yyyy", visible:false},
            { dataField: "userdefineddate7", caption: "Date 7", dataType: "datetime", format:"MM/dd/yyyy", visible:false},
            { dataField: "userdefineddate8", caption: "Date 8", dataType: "datetime", format:"MM/dd/yyyy", visible:false},
            { dataField: "userdefineddate9", caption: "Date 9", dataType: "datetime", format:"MM/dd/yyyy", visible:false},
            { dataField: "userdefineddate10", caption: "Date 10", dataType: "datetime", format:"MM/dd/yyyy", visible:false},
            { dataField: "userdefinedquantity1", caption: "Quantity 1", dataType: "number", format:{ type: 'fixedPoint', precision: 2, useGrouping: true }, visible:false},
            { dataField: "userdefinedquantity2", caption: "Quantity 2", dataType: "number", format:{ type: 'fixedPoint', precision: 2, useGrouping: true }, visible:false},
            { dataField: "userdefinedquantity3", caption: "Quantity 3", dataType: "number", format:{ type: 'fixedPoint', precision: 2, useGrouping: true }, visible:false},
            { dataField: "userdefinedquantity4", caption: "Quantity 4", dataType: "number", format:{ type: 'fixedPoint', precision: 2, useGrouping: true }, visible:false},
            { dataField: "userdefinedquantity5", caption: "Quantity 5", dataType: "number", format:{ type: 'fixedPoint', precision: 2, useGrouping: true }, visible:false},
            { dataField: "userdefinedquantity6", caption: "Quantity 6", dataType: "number", format:{ type: 'fixedPoint', precision: 2, useGrouping: true }, visible:false},
            { dataField: "userdefinedquantity7", caption: "Quantity 7", dataType: "number", format:{ type: 'fixedPoint', precision: 2, useGrouping: true }, visible:false},
            { dataField: "userdefinedquantity8", caption: "Quantity 8", dataType: "number", format:{ type: 'fixedPoint', precision: 2, useGrouping: true }, visible:false},
            { dataField: "userdefinedquantity9", caption: "Quantity 9", dataType: "number", format:{ type: 'fixedPoint', precision: 2, useGrouping: true }, visible:false},
            { dataField: "userdefinedquantity10", caption: "Quantity 10", dataType: "number", format:{ type: 'fixedPoint', precision: 2, useGrouping: true }, visible:false},
            { dataField: "customer", caption: "Customer", dataType: "string", visible:false},
            { dataField: "customername", caption: "Customer Name", dataType: "string", visible:false},
            { dataField: "effectivedate", caption: "Effective Date", dataType: "datetime", format:"MM/dd/yyyy", visible:false},
            { dataField: "itemclass", caption: "Item Class", dataType: "string", visible:false},
            { dataField: "itemsubclass", caption: "Item Sub Class", dataType: "string", visible:false},
            { dataField: "popupmessage", caption: "Popup Message", dataType: "string", visible:false},
            { dataField: "status", caption: "Status", dataType: "string", visible:false},
        ]
    };
}
const WMTransactionDPLookupLayout = {
    valueExpr: 'rowid',
    displayExpr: 'profilecode',
    sort: [{ selector: "profilecode", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '15D2A80C-B6D1-4001-9F51-E382B955D874',
    params: {
        module: "wm",
        lookupType: "TransactionDP",
        showLookupGrid: true
    },
    columns:  [
         { visible:false, dataField: "record",caption: "Record", dataType: "string" },
         { visible:false, dataField: "creationdatetime",caption: "Creation Date", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a" },
         { visible:false, dataField: "creationuserid",caption: "Created By", dataType: "string" },
         { visible:false, dataField: "lastupdatedatetime",caption: "Last Updated", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a" },
         { visible:false, dataField: "lastupdateuserid",caption: "Last Updated By", dataType: "string" },
         { visible:true, dataField: "profilecode",caption: "Profile", dataType: "string" },
         { visible:true, dataField: "description",caption: "Description", dataType: "string" },
         { visible:false, dataField: "arcommitmethod",caption: "Arcommitmethod", dataType: "string" },
         { visible:false, dataField: "openitemreference",caption: "Openitemreference", dataType: "string" },
         { visible:false, dataField: "commitdateoption",caption: "Commit Date", dataType: "string" },
         { visible:false, dataField: "allowduplicatepo",caption: "Allow Duplicate PO", dataType: "string" },
         { visible:false, dataField: "uselocation",caption: "Uselocation", dataType: "string" },
         { visible:false, dataField: "userdefinedcode1",caption: "Code 1", dataType: "string" },
         { visible:false, dataField: "userdefinedcode2",caption: "Code 2", dataType: "string" },
         { visible:false, dataField: "userdefinedcode3",caption: "Code 3", dataType: "string" },
         { visible:false, dataField: "userdefinedcode4",caption: "Code 4", dataType: "string" },
         { visible:false, dataField: "userdefinedcode5",caption: "Code 5", dataType: "string" },
    ]
};
const WMItemKitHeaderDpLookupLayout = {
    valueExpr: 'id',
    displayExpr: 'profilecode',
    sort: [{ selector: "profilecode", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'B3E37DAA-A48A-4D43-94F2-9AC787FAF4ED',
    params: {
        module: "im",
        lookupType: "ItemKitHeaderDp",
        showLookupGrid: true
    },
    columns: [
        { visible: false, dataField: "id", caption: "ID", dataType: "string" },
        { visible: true, dataField: "profilecode", caption: "Profile Code", dataType: "string" },
        { visible: true, dataField: "description", caption: "Description", dataType: "string" },
        { visible: false, dataField: "recordNumber", caption: "Record #", dataType: "string" },
        { visible: false, dataField: "comment", caption: "Comment", dataType: "string" },
        { visible: false, dataField: "creationDateTime", caption: "Creation Date", dataType: "datetime", format: "MM/dd/yyyy hh:mm:ss a" },
        { visible: false, dataField: "creationUserId", caption: "Created By", dataType: "string" },
        { visible: false, dataField: "lastUpdateDateTime", caption: "Last Updated", dataType: "datetime", format: "MM/dd/yyyy hh:mm:ss a" },
        { visible: false, dataField: "lastUpdateUserId", caption: "Last Updated By", dataType: "string" },
        { visible: false, dataField: "userDefinedCode1", caption: "Code 1", dataType: "string" },
        { visible: false, dataField: "userDefinedCode2", caption: "Code 2", dataType: "string" },
        { visible: false, dataField: "userDefinedCode3", caption: "Code 3", dataType: "string" },
        { visible: false, dataField: "userDefinedCode4", caption: "Code 4", dataType: "string" },
        { visible: false, dataField: "userDefinedCode5", caption: "Code 5", dataType: "string" },
    ]
};
const WMStorageMiscDpLookupLayout = {
    valueExpr: 'rowId',
    displayExpr: 'profileCode',
    sort: [{ selector: "profileCode", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '51A9856E-A84D-41CA-894D-5D9D7E588DFA',
    params: {
        module: "wm",
        lookupType: "WMStorageMiscDp",
        showLookupGrid: true
    },
    columns:  [
        { visible:false, dataField: "record",caption: "Record", dataType: "string" },
        { visible:false, dataField: "creationDateTime",caption: "Creation Date", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a" },
        { visible:false, dataField: "creationUserId",caption: "Created By", dataType: "string" },
        { visible:false, dataField: "lastUpdateDateTime",caption: "Last Updated", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a" },
        { visible:false, dataField: "lastUpdateUserId",caption: "Last Updated By", dataType: "string" },
        { visible:true, dataField: "profileCode",caption: "Profile Code", dataType: "string" },
        { visible:true, dataField: "description",caption: "Description", dataType: "string" },
        { visible:false, dataField: "comment",caption: "Comment", dataType: "string" },
        { visible:false, dataField: "userDefinedCode1",caption: "Code 1", dataType: "string" },
        { visible:false, dataField: "userDefinedCode2",caption: "Code 2", dataType: "string" },
        { visible:false, dataField: "userDefinedCode3",caption: "Code 3", dataType: "string" },
        { visible:false, dataField: "userDefinedCode4",caption: "Code 4", dataType: "string" },
        { visible:false, dataField: "userDefinedCode5",caption: "Code 5", dataType: "string" },
        { visible:false, dataField: "chargeTypes",caption: "Charge Types", dataType: "string" },
        { visible:false, dataField: "recurringCharge",caption: "Recurring Charge", dataType: "string" },
        { visible:false, dataField: "transNoGenerationMisc",caption: "Trans No Generation Misc", dataType: "string" },
        { visible:false, dataField: "transactionPrefix",caption: "Transaction Prefix", dataType: "string" },
        { visible:false, dataField: "allowDuplicatePo",caption: "Allow Duplicate PO", dataType: "string" },
    ]
};

const WMChargeDpLookupLayout = {
    valueExpr: 'rowId',
    displayExpr: 'profileCode',
    sort: [{ selector: "profileCode", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'A1B2C3D4-E5F6-7890-ABCD-EF1234567890',
    params: {
        module: "wm",
        lookupType: "ChargeDp",
        showLookupGrid: true
    },
    columns:  [
        { visible:false, dataField: "keySequence",caption: "Key Sequence", dataType: "number" },
        { visible:false, dataField: "creationDateTime",caption: "Creation Date", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a" },
        { visible:false, dataField: "creationUserId",caption: "Created By", dataType: "string" },
        { visible:false, dataField: "lastUpdateDateTime",caption: "Last Updated", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a" },
        { visible:false, dataField: "lastUpdateUserId",caption: "Last Updated By", dataType: "string" },
        { visible:true, dataField: "profileCode",caption: "Profile Code", dataType: "string" },
        { visible:true, dataField: "description",caption: "Description", dataType: "string" },
        { visible:false, dataField: "comment",caption: "Comment", dataType: "string" },
        { visible:false, dataField: "rCharges",caption: "R Charges", dataType: "string" },
        { visible:false, dataField: "userDefinedCode1",caption: "Code 1", dataType: "string" },
        { visible:false, dataField: "userDefinedCode2",caption: "Code 2", dataType: "string" },
        { visible:false, dataField: "userDefinedCode3",caption: "Code 3", dataType: "string" },
        { visible:false, dataField: "userDefinedCode4",caption: "Code 4", dataType: "string" },
        { visible:false, dataField: "userDefinedCode5",caption: "Code 5", dataType: "string" },
    ]
};

const WMRateScheduleDpLookupLayout = {
    valueExpr: 'rowId',
    displayExpr: 'profileCode',
    sort: [{ selector: "profileCode", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'C3D4E5F6-A7B8-9012-CDEF-234567890ABC',
    params: {
        module: "wm",
        lookupType: "RateScheduleDp",
        showLookupGrid: true
    },
    columns:  [
        { visible:false, dataField: "record",caption: "Record", dataType: "string" },
        { visible:false, dataField: "creationDateTime",caption: "Creation Date", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a" },
        { visible:false, dataField: "creationUserId",caption: "Created By", dataType: "string" },
        { visible:false, dataField: "lastUpdateDateTime",caption: "Last Updated", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a" },
        { visible:false, dataField: "lastUpdateUserId",caption: "Last Updated By", dataType: "string" },
        { visible:false, dataField: "companyId",caption: "Company ID", dataType: "string" },
        { visible:false, dataField: "module",caption: "Module", dataType: "string" },
        { visible:false, dataField: "recordType",caption: "Record Type", dataType: "string" },
        { visible:true, dataField: "profileCode",caption: "Profile Code", dataType: "string" },
        { visible:true, dataField: "description",caption: "Description", dataType: "string" },
        { visible:false, dataField: "comment",caption: "Comment", dataType: "string" },
        { visible:false, dataField: "userDefinedCode1",caption: "Code 1", dataType: "string" },
        { visible:false, dataField: "userDefinedCode2",caption: "Code 2", dataType: "string" },
        { visible:false, dataField: "userDefinedCode3",caption: "Code 3", dataType: "string" },
        { visible:false, dataField: "userDefinedCode4",caption: "Code 4", dataType: "string" },
        { visible:false, dataField: "userDefinedCode5",caption: "Code 5", dataType: "string" },
    ]
};

const WMRateTableHeaderLookupLayout = {
    valueExpr: 'rowId',
    displayExpr: 'rateCode',
    sort: [{ selector: "rateCode", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'B2C3D4E5-F6A7-8901-BCDE-F12345678901',
    params: {
        module: "wm",
        lookupType: "RateTableHeader",
        showLookupGrid: true
    },
    columns:  [
        { visible:false, dataField: "record",caption: "Record", dataType: "string" },
        { visible:false, dataField: "creationDateTime",caption: "Creation Date", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a" },
        { visible:false, dataField: "creationUserId",caption: "Created By", dataType: "string" },
        { visible:false, dataField: "lastUpdateDateTime",caption: "Last Updated", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a" },
        { visible:false, dataField: "lastUpdateUserId",caption: "Last Updated By", dataType: "string" },
        { visible:false, dataField: "companyId",caption: "Company ID", dataType: "string" },
        { visible:false, dataField: "module",caption: "Module", dataType: "string" },
        { visible:false, dataField: "recordType",caption: "Record Type", dataType: "string" },
        { visible:false, dataField: "status",caption: "Status", dataType: "string" },
        { visible:true, dataField: "rateCode",caption: "Rate Code", dataType: "string" },
        { visible:true, dataField: "description",caption: "Description", dataType: "string" },
        { visible:false, dataField: "profileGuid",caption: "Profile Guid", dataType: "string" },
    ]
};

const WMChargeCodeLookupLayout = {
    valueExpr: 'rowId',
    displayExpr: 'chargeCode',
    sort: [{ selector: "chargeCode", desc: false }],
    searchEnabled: true,
    acceptCustomValue: true,
    gridKey: 'D4E5F6A7-B8C9-0123-DEF4-567890ABCDEF',
    params: {
        module: "wm",
        lookupType: "WMChargeCode",
        showLookupGrid: true
    },
    columns: [
        { visible: false, dataField: "record", caption: "Record", dataType: "string" },
        { visible: false, dataField: "creationDateTime", caption: "Creation Date", dataType: "datetime", format: "MM/dd/yyyy hh:mm:ss a" },
        { visible: false, dataField: "creationUserId", caption: "Created By", dataType: "string" },
        { visible: false, dataField: "lastUpdateDateTime", caption: "Last Updated", dataType: "datetime", format: "MM/dd/yyyy hh:mm:ss a" },
        { visible: false, dataField: "lastUpdateUserId", caption: "Last Updated By", dataType: "string" },
        { visible: true, dataField: "chargeCode", caption: "Charge Code", dataType: "string" },
        { visible: true, dataField: "description", caption: "Description", dataType: "string" },
        { visible: false, dataField: "chargeType", caption: "Charge Type", dataType: "string" },
        { visible: false, dataField: "status", caption: "Status", dataType: "string" },
    ]
};

// Labor-tracking source transaction (Delphi P_SOURCEKEYSEQUENCE). Value = header
// RowId, display = transaction number.
const WMTransactionHeaderLookupLayout = {
    valueExpr: 'id',
    displayExpr: 'transactionnumber',
    sort: [{ selector: "transactionnumber", desc: false }],
    searchEnabled: true,
    acceptCustomValue: true,
    gridKey: 'A1F3C7E9-6B24-4D85-9E10-73C2B48F0A6D',
    selectboxlabel: 'Transaction',
    params: {
        module: "wm",
        lookupType: "WMTransactionHeader",
        showLookupGrid: true,
    },
    columns: [
        { dataField: "transactionnumber", caption: "Transaction #", dataType: "string" },
        { dataField: "transactiontype", caption: "Type", dataType: "string", visible: false },
    ]
};

// WM code types (WMCODETYPE) — Descriptive Codes "Type" lookup.
const WMCodeTypesLookupLayout = (customParams = {}) => {
    return {
        valueExpr: customParams.valueExpr ?? 'CodeType',
        displayExpr: customParams.displayExpr ?? 'CodeType',
        sort: [{ selector: customParams.displayExpr ?? "CodeType", desc: false }],
        searchEnabled: true,
        acceptCustomValue: true,
        gridKey: 'F6A2C9D4-3E71-4B58-8A0C-52D7B1E6F3A9',
        params: {
            module: "wm",
            lookupType: "WMCodeType",
            showLookupGrid: true,
            isPascalCase: true
        },
        columns: [
            { dataField: "CodeType", caption: "Code", dataType: "string" },
            { dataField: "Description", caption: "Description", dataType: "string" },
        ]
    };
}
// WM "Lot" items for a customer (Transfer Lots to Different Items — Original/Transfer
// item). Value = item RowId, display = item code. Pass the selected customer's RowId
// so only that customer's lot items are returned.
const WMLotItemLookupLayout = (customerRowId = "") => ({
    valueExpr: 'id',
    displayExpr: 'itemcode',
    sort: [{ selector: "itemcode", desc: false }],
    searchEnabled: true,
    acceptCustomValue: true,
    gridKey: 'E9B2D4C7-1A63-4F58-8D02-6C7B9E3A5F1D',
    selectboxlabel: 'Item',
    params: {
        module: "wm",
        lookupType: "WMLotItem",
        showLookupGrid: true,
        customerRowId: customerRowId || "",
    },
    columns: [
        { dataField: "itemcode", caption: "Item Code", dataType: "string" },
        { dataField: "description1", caption: "Description 1", dataType: "string" },
        { dataField: "description2", caption: "Description 2", dataType: "string" },
    ]
});

// SubLot-type items scoped to a customer (Transfer Sublots to Different Items — Delphi WMD0097,
// IMItem.ItemType = 'S'). Value = item RowId, display = item code.
const WMSubLotItemLookupLayout = (customerRowId = "") => ({
    valueExpr: 'id',
    displayExpr: 'itemcode',
    sort: [{ selector: "itemcode", desc: false }],
    searchEnabled: true,
    acceptCustomValue: true,
    gridKey: 'B3F7D1A9-4C62-4E80-9B15-7A2E6C9D3F84',
    selectboxlabel: 'Item',
    params: {
        module: "wm",
        lookupType: "WMSubLotItem",
        showLookupGrid: true,
        customerRowId: customerRowId || "",
    },
    columns: [
        { dataField: "itemcode", caption: "Item Code", dataType: "string" },
        { dataField: "description1", caption: "Description 1", dataType: "string" },
        { dataField: "description2", caption: "Description 2", dataType: "string" },
    ]
});

// Lots of a given item (WMD0098 Filter Item popup — filter the Find-Lots grid by a single
// lot). Value = lot RowId, display = lot code. Pass the original item's RowId to scope it.
const WMLotByItemLookupLayout = (itemRowId = "") => ({
    valueExpr: 'id',
    displayExpr: 'lotcode',
    sort: [{ selector: "lotcode", desc: false }],
    searchEnabled: true,
    acceptCustomValue: true,
    gridKey: 'C4E8A2F6-7B39-4D51-9A08-3E6C1B7D5F2A',
    selectboxlabel: 'Lot',
    params: {
        module: "wm",
        lookupType: "WMLotByItem",
        showLookupGrid: true,
        itemRowId: itemRowId || "",
    },
    columns: [
        // Default-visible columns — mirror the Delphi lot-lookup grid header.
        { dataField: "lotcode", caption: "Lot", dataType: "string" },
        { dataField: "description1", caption: "Description - 1", dataType: "string" },
        { dataField: "reorderinventoryminimumqty", caption: "Minimum Qty", dataType: "number" },
        { dataField: "reorderinventorymaximumqty", caption: "Maximum Qty", dataType: "number" },
        { dataField: "available", caption: "Available", dataType: "number" },
        { dataField: "progressivecurrentrate", caption: "Current Rate", dataType: "number" },
        { dataField: "progressivelastrate", caption: "Last Rate", dataType: "number" },
        { dataField: "progressivepreviouslastrate", caption: "Prev Last Rate", dataType: "number" },
        { dataField: "progressivebillingcount", caption: "# Bills", dataType: "number" },
        // Additional columns — hidden by default, available via the column chooser (like Delphi).
        { dataField: "description2", caption: "Description - 2", dataType: "string", visible: false },
        { dataField: "status", caption: "Status", dataType: "string", visible: false },
        { dataField: "classcode", caption: "Class", dataType: "string", visible: false },
        { dataField: "subclasscode", caption: "Sub Class", dataType: "string", visible: false },
        { dataField: "lotsizecode", caption: "Lot Size Code", dataType: "string", visible: false },
        { dataField: "lotprojectioncode", caption: "Projection Code", dataType: "string", visible: false },
        { dataField: "size1", caption: "Size - 1", dataType: "number", visible: false },
        { dataField: "size2", caption: "Size - 2", dataType: "number", visible: false },
        { dataField: "keysequence", caption: "Record #", dataType: "number", visible: false },
        { dataField: "recurringstorage", caption: "Recurring Flag", dataType: "string", visible: false },
        { dataField: "physicalcountcode", caption: "Count Cycle", dataType: "string", visible: false },
        { dataField: "oemmanufacturercode", caption: "OEM Code", dataType: "string", visible: false },
        { dataField: "routecode", caption: "Routecode", dataType: "string", visible: false },
        { dataField: "vendoritemcode", caption: "Vendor Item", dataType: "string", visible: false },
        // Dates
        { dataField: "dateintroduced", caption: "Introduced Dt", dataType: "date", visible: false },
        { dataField: "dateavailable", caption: "Available Dt", dataType: "date", visible: false },
        { dataField: "dateexpiration", caption: "Expiration Dt", dataType: "date", visible: false },
        { dataField: "datelastreceipt", caption: "Last Receipt Dt", dataType: "date", visible: false },
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "date", visible: false },
        { dataField: "creationuserid", caption: "Created By", dataType: "string", visible: false },
        { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "date", visible: false },
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible: false },
        // Reorder / quantities
        { dataField: "reorderquantityeoqcalculated", caption: "Calculated Qty", dataType: "number", visible: false },
        { dataField: "reorderquantityentered", caption: "Entered Qty", dataType: "number", visible: false },
        { dataField: "reorderquantityordermultiple", caption: "Order Multiple", dataType: "number", visible: false },
        { dataField: "reorderleadtime", caption: "Lead Days", dataType: "number", visible: false },
        { dataField: "reorderminimumdaysonhand", caption: "Minimum Days", dataType: "number", visible: false },
        { dataField: "reordermaximumdaysonhand", caption: "Maximum Days", dataType: "number", visible: false },
        { dataField: "reordersafetyquantity", caption: "Safety Qty", dataType: "number", visible: false },
        { dataField: "salemaxquantity", caption: "Max Sale Qty", dataType: "number", visible: false },
        { dataField: "oversellpercentage", caption: "Oversell %", dataType: "number", visible: false },
        // Costs
        { dataField: "averagecost", caption: "Average Cost", dataType: "number", visible: false },
        { dataField: "standardcost", caption: "Standard Cost", dataType: "number", visible: false },
        { dataField: "lastcost", caption: "Last Cost", dataType: "number", visible: false },
        { dataField: "costbasismethodflag", caption: "Cost Basis", dataType: "string", visible: false },
        // Inventory status
        { dataField: "onhand", caption: "On Hand", dataType: "number", visible: false },
        { dataField: "netavailable", caption: "Net Available", dataType: "number", visible: false },
        { dataField: "inreceiving", caption: "In Receiving", dataType: "number", visible: false },
        { dataField: "outshipped", caption: "In Shipping", dataType: "number", visible: false },
        { dataField: "inordered", caption: "Pending Rec", dataType: "number", visible: false },
        { dataField: "outordered", caption: "Pending Ship", dataType: "number", visible: false },
        { dataField: "inbackorder", caption: "BO-Receiving", dataType: "number", visible: false },
        { dataField: "outbackorder", caption: "BO-Shipping", dataType: "number", visible: false },
        { dataField: "inunavailable", caption: "Unavailable", dataType: "number", visible: false },
        { dataField: "outunavailable", caption: "Unavailable", dataType: "number", visible: false },
        { dataField: "infuture", caption: "Future Rec", dataType: "number", visible: false },
        { dataField: "outfuture", caption: "Future Ship", dataType: "number", visible: false },
        // Data-dictionary relabeled captions — wired to otherwise-unused fields (Code 1-5 +
        // a few spare fields). Adjust the dataField mapping if the DB dictionary differs.
        { dataField: "userdefinedcode1", caption: "% Foreign", dataType: "string", visible: false },
        { dataField: "userdefinedcode2", caption: "% Germination", dataType: "string", visible: false },
        { dataField: "userdefinedcode3", caption: "% Moisture", dataType: "string", visible: false },
        { dataField: "userdefinedcode4", caption: "Attribute 4", dataType: "string", visible: false },
        { dataField: "userdefinedcode5", caption: "Attribute 5", dataType: "string", visible: false },
        { dataField: "itemsupccode", caption: "Alternate SKU", dataType: "string", visible: false },
        { dataField: "coreprice", caption: "Code Price", dataType: "number", visible: false },
        { dataField: "storagebillingstartdate", caption: "First Receipt", dataType: "date", visible: false },
        // User-defined Codes 6-10
        { dataField: "userdefinedcode6", caption: "Code 6", dataType: "string", visible: false },
        { dataField: "userdefinedcode7", caption: "Code 7", dataType: "string", visible: false },
        { dataField: "userdefinedcode8", caption: "Code 8", dataType: "string", visible: false },
        { dataField: "userdefinedcode9", caption: "Code 9", dataType: "string", visible: false },
        { dataField: "userdefinedcode10", caption: "Code 10", dataType: "string", visible: false },
        // User-defined References 1-10
        { dataField: "userdefinedreference1", caption: "Reference 1", dataType: "string", visible: false },
        { dataField: "userdefinedreference2", caption: "Reference 2", dataType: "string", visible: false },
        { dataField: "userdefinedreference3", caption: "Reference 3", dataType: "string", visible: false },
        { dataField: "userdefinedreference4", caption: "Reference 4", dataType: "string", visible: false },
        { dataField: "userdefinedreference5", caption: "Reference 5", dataType: "string", visible: false },
        { dataField: "userdefinedreference6", caption: "Reference 6", dataType: "string", visible: false },
        { dataField: "userdefinedreference7", caption: "Reference 7", dataType: "string", visible: false },
        { dataField: "userdefinedreference8", caption: "Reference 8", dataType: "string", visible: false },
        { dataField: "userdefinedreference9", caption: "Reference 9", dataType: "string", visible: false },
        { dataField: "userdefinedreference10", caption: "Reference 10", dataType: "string", visible: false },
        // User-defined Dates 1-10
        { dataField: "userdefineddate1", caption: "Date 1", dataType: "date", visible: false },
        { dataField: "userdefineddate2", caption: "Date 2", dataType: "date", visible: false },
        { dataField: "userdefineddate3", caption: "Date 3", dataType: "date", visible: false },
        { dataField: "userdefineddate4", caption: "Date 4", dataType: "date", visible: false },
        { dataField: "userdefineddate5", caption: "Date 5", dataType: "date", visible: false },
        { dataField: "userdefineddate6", caption: "Date 6", dataType: "date", visible: false },
        { dataField: "userdefineddate7", caption: "Date 7", dataType: "date", visible: false },
        { dataField: "userdefineddate8", caption: "Date 8", dataType: "date", visible: false },
        { dataField: "userdefineddate9", caption: "Date 9", dataType: "date", visible: false },
        { dataField: "userdefineddate10", caption: "Date 10", dataType: "date", visible: false },
        // User-defined Quantities 1-10
        { dataField: "userdefinedquantity1", caption: "Quantity 1", dataType: "number", visible: false },
        { dataField: "userdefinedquantity2", caption: "Quantity 2", dataType: "number", visible: false },
        { dataField: "userdefinedquantity3", caption: "Quantity 3", dataType: "number", visible: false },
        { dataField: "userdefinedquantity4", caption: "Quantity 4", dataType: "number", visible: false },
        { dataField: "userdefinedquantity5", caption: "Quantity 5", dataType: "number", visible: false },
        { dataField: "userdefinedquantity6", caption: "Quantity 6", dataType: "number", visible: false },
        { dataField: "userdefinedquantity7", caption: "Quantity 7", dataType: "number", visible: false },
        { dataField: "userdefinedquantity8", caption: "Quantity 8", dataType: "number", visible: false },
        { dataField: "userdefinedquantity9", caption: "Quantity 9", dataType: "number", visible: false },
        { dataField: "userdefinedquantity10", caption: "Quantity 10", dataType: "number", visible: false },
    ]
});

// Sublot picker (Filter Item popup "SubLot" lookup on the Transfer Lots screen), scoped to a lot.
// Mirrors the legacy WMD0128 sublot lookup grid + column chooser.
const WMSublotByLotLookupLayout = (lotRowId = "") => ({
    valueExpr: 'id',
    displayExpr: 'sublotcode',
    sort: [{ selector: "sublotcode", desc: false }],
    searchEnabled: true,
    acceptCustomValue: true,
    gridKey: 'B2D7F4A9-1C63-4E58-8A20-6F3C9B1D7E4B',
    selectboxlabel: 'SubLot',
    params: {
        module: "wm",
        lookupType: "WMSublotByLot",
        showLookupGrid: true,
        lotRowId: lotRowId || "",
    },
    columns: [
        // Default-visible columns — mirror the Delphi sublot-lookup grid header.
        { dataField: "sublotcode", caption: "Sublot", dataType: "string" },
        { dataField: "description1", caption: "Description - 1", dataType: "string" },
        { dataField: "status", caption: "Status", dataType: "string" },
        { dataField: "available", caption: "Available", dataType: "number" },
        { dataField: "tareweight", caption: "Unit Tare Wt", dataType: "number" },
        // Additional columns — hidden by default, available via the column chooser (like Delphi).
        { dataField: "description2", caption: "Description - 2", dataType: "string", visible: false },
        { dataField: "alternateid", caption: "Alternate ID", dataType: "string", visible: false },
        { dataField: "keysequence", caption: "Record #", dataType: "number", visible: false },
        { dataField: "recurringstorage", caption: "Recurring Flag", dataType: "string", visible: false },
        { dataField: "unitprice", caption: "Unitprice", dataType: "number", visible: false },
        { dataField: "size1", caption: "Size - 1", dataType: "number", visible: false },
        { dataField: "size2", caption: "Size - 2", dataType: "number", visible: false },
        // Dates
        { dataField: "dateintroduced", caption: "Introduced Dt", dataType: "date", visible: false },
        { dataField: "dateavailable", caption: "Available Dt", dataType: "date", visible: false },
        { dataField: "dateexpiration", caption: "Expiration Dt", dataType: "date", visible: false },
        { dataField: "storagebillingstartdate", caption: "First Receipt", dataType: "date", visible: false },
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "date", visible: false },
        { dataField: "creationuserid", caption: "Created By", dataType: "string", visible: false },
        { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "date", visible: false },
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible: false },
        // Inventory status
        { dataField: "onhand", caption: "On Hand", dataType: "number", visible: false },
        { dataField: "netavailable", caption: "Net Available", dataType: "number", visible: false },
        { dataField: "inreceiving", caption: "In Receiving", dataType: "number", visible: false },
        { dataField: "outshipped", caption: "In Shipping", dataType: "number", visible: false },
        { dataField: "inordered", caption: "Pending Rec", dataType: "number", visible: false },
        { dataField: "outordered", caption: "Pending Ship", dataType: "number", visible: false },
        { dataField: "inbackorder", caption: "BO-Receiving", dataType: "number", visible: false },
        { dataField: "outbackorder", caption: "BO-Shipping", dataType: "number", visible: false },
        { dataField: "inunavailable", caption: "Unavailable", dataType: "number", visible: false },
        { dataField: "outunavailable", caption: "Unavailable", dataType: "number", visible: false },
        { dataField: "infuture", caption: "Future Rec", dataType: "number", visible: false },
        { dataField: "outfuture", caption: "Future Ship", dataType: "number", visible: false },
        // User-defined Codes 1-10
        { dataField: "userdefinedcode1", caption: "Code 1", dataType: "string", visible: false },
        { dataField: "userdefinedcode2", caption: "Code 2", dataType: "string", visible: false },
        { dataField: "userdefinedcode3", caption: "Code 3", dataType: "string", visible: false },
        { dataField: "userdefinedcode4", caption: "Code 4", dataType: "string", visible: false },
        { dataField: "userdefinedcode5", caption: "Code 5", dataType: "string", visible: false },
        { dataField: "userdefinedcode6", caption: "Code 6", dataType: "string", visible: false },
        { dataField: "userdefinedcode7", caption: "Code 7", dataType: "string", visible: false },
        { dataField: "userdefinedcode8", caption: "Code 8", dataType: "string", visible: false },
        { dataField: "userdefinedcode9", caption: "Code 9", dataType: "string", visible: false },
        { dataField: "userdefinedcode10", caption: "Code 10", dataType: "string", visible: false },
        // User-defined References 1-10
        { dataField: "userdefinedreference1", caption: "Reference 1", dataType: "string", visible: false },
        { dataField: "userdefinedreference2", caption: "Reference 2", dataType: "string", visible: false },
        { dataField: "userdefinedreference3", caption: "Reference 3", dataType: "string", visible: false },
        { dataField: "userdefinedreference4", caption: "Reference 4", dataType: "string", visible: false },
        { dataField: "userdefinedreference5", caption: "Reference 5", dataType: "string", visible: false },
        { dataField: "userdefinedreference6", caption: "Reference 6", dataType: "string", visible: false },
        { dataField: "userdefinedreference7", caption: "Reference 7", dataType: "string", visible: false },
        { dataField: "userdefinedreference8", caption: "Reference 8", dataType: "string", visible: false },
        { dataField: "userdefinedreference9", caption: "Reference 9", dataType: "string", visible: false },
        { dataField: "userdefinedreference10", caption: "Reference 10", dataType: "string", visible: false },
        // User-defined Dates 1-10
        { dataField: "userdefineddate1", caption: "Date 1", dataType: "date", visible: false },
        { dataField: "userdefineddate2", caption: "Date 2", dataType: "date", visible: false },
        { dataField: "userdefineddate3", caption: "Date 3", dataType: "date", visible: false },
        { dataField: "userdefineddate4", caption: "Date 4", dataType: "date", visible: false },
        { dataField: "userdefineddate5", caption: "Date 5", dataType: "date", visible: false },
        { dataField: "userdefineddate6", caption: "Date 6", dataType: "date", visible: false },
        { dataField: "userdefineddate7", caption: "Date 7", dataType: "date", visible: false },
        { dataField: "userdefineddate8", caption: "Date 8", dataType: "date", visible: false },
        { dataField: "userdefineddate9", caption: "Date 9", dataType: "date", visible: false },
        { dataField: "userdefineddate10", caption: "Date 10", dataType: "date", visible: false },
        // User-defined Quantities 1-10
        { dataField: "userdefinedquantity1", caption: "Quantity 1", dataType: "number", visible: false },
        { dataField: "userdefinedquantity2", caption: "Quantity 2", dataType: "number", visible: false },
        { dataField: "userdefinedquantity3", caption: "Quantity 3", dataType: "number", visible: false },
        { dataField: "userdefinedquantity4", caption: "Quantity 4", dataType: "number", visible: false },
        { dataField: "userdefinedquantity5", caption: "Quantity 5", dataType: "number", visible: false },
        { dataField: "userdefinedquantity6", caption: "Quantity 6", dataType: "number", visible: false },
        { dataField: "userdefinedquantity7", caption: "Quantity 7", dataType: "number", visible: false },
        { dataField: "userdefinedquantity8", caption: "Quantity 8", dataType: "number", visible: false },
        { dataField: "userdefinedquantity9", caption: "Quantity 9", dataType: "number", visible: false },
        { dataField: "userdefinedquantity10", caption: "Quantity 10", dataType: "number", visible: false },
    ]
});

export {
    WMItemDpLookupLayout,
    WMCodesLookupLayout,
    WMDescriptiveCodesLookupLayout,
    WMRateScheduleHeaderLookupLayout,
    WMTransactionDPLookupLayout,
    WMItemKitHeaderDpLookupLayout,
    WMStorageMiscDpLookupLayout,
    WMChargeDpLookupLayout,
    WMRateTableHeaderLookupLayout,
    WMRateScheduleDpLookupLayout,
    WMChargeCodeLookupLayout,
    WMTransactionHeaderLookupLayout,
    WMCodeTypesLookupLayout,
    WMLotItemLookupLayout,
    WMSubLotItemLookupLayout,
    WMLotByItemLookupLayout,
    WMSublotByLotLookupLayout
}